import axios from "axios"
var departmentUrl = 'user/department'
var roleUrl = 'user/role'
var permissionUrl = 'user/permissions'
export default {
    async getDepartments(data, search) {
        var url = `${departmentUrl}?page=${data.page}&limit=${data.itemsPerPage}`;
        if (data.sortBy.length === 1 && data.sortDesc.length === 1)
            url = `${url}&col=${data.sortBy[0]}&desc=${data.sortDesc[0]}`
        if (search.length)
            url = `${url}&search=${search}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(err => err)
    },
    async createDepartment(department) {
        return await axios.post(departmentUrl, department)
            .then(({ data }) => data)
            .catch(err => err)
    },
    async updateDepartment(department) {
        return await axios.put(departmentUrl, department)
            .then(({ data }) => data)
            .catch(err => err)
    },

    async getRoles(data, department, search) {
        var url = `${roleUrl}?page=${data.page}&limit=${data.itemsPerPage}&department=${department}`;
        if (data.sortBy.length === 1 && data.sortDesc.length === 1)
            url = `${url}&col=${data.sortBy[0]}&desc=${data.sortDesc[0]}`
        if (search.length)
            url = `${url}&search=${search}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(err => err)
    },
    async createRole(role) {
        return await axios.post(roleUrl, role)
            .then(({ data }) => data)
            .catch(err => err)
    },
    async updateRole(role) {
        return await axios.put(roleUrl, role)
            .then(({ data }) => data)
            .catch(err => err)
    },
    async getDeptList(data) {
        var url = `${departmentUrl}?page=${data.page}&limit=${data.itemsPerPage}&col=${data.sortBy[0]}&desc=${data.sortDesc[0]}`;

        try {
            const resp = await axios.get(url);
            return resp.data.data.departments.rows;
        } catch (err) {
            console.log(err)
            return []
        }
    },
    async getRoleList(data, department) {
        var url = `${roleUrl}?page=${data.page}&limit=${data.itemsPerPage}&col=${data.sortBy[0]}&desc=${data.sortDesc[0]}&department=${department}`;
        try {
            const resp = await axios.get(url);
            return resp.data.data.roles.rows;
        } catch (err) {
            console.log(err)
            return []
        }
    },

    async getRolePermissions(dataOptions, dept, role, search = '') {
        console.log(dept, 'depth>>>>>>>>>s')
        var url = `${permissionUrl}?role=${role}&department=${dept}&page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if (search != '')
            url = `${url}&search=${search}`
        try {
            return await axios.get(url);
        } catch (err) {
            console.log(err)
            return []
        }
    },

    async updateRolePermissions(permissions) {
        try {
            const resp = await axios.put(permissionUrl, permissions);
            return resp.data
        } catch (err) {
            console.log(err.response.data)
            return []
        }
    },

    async deleteDepartment(department) {
        try {
            const resp = await axios.delete(departmentUrl, { data: department });
            return Promise.resolve(resp.data)
        } catch (err) {
            return Promise.reject(err.response.data)
        }
    },
}